import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { addContentFavorite, removeContentFavorite } from '../../actions/spaces/FavoritesActions';
import { MapDispatchToProps } from '../../utils/ConnectUtils';
import { ListView, ListViewDispatchProps, ListViewOwnProps } from './ListView';

const mapDispatchToProps: MapDispatchToProps<ListViewDispatchProps> = (dispatch) => bindActionCreators({
  addContentFavorite: addContentFavorite,
  removeContentFavorite: removeContentFavorite,
}, dispatch);

export const ConnectedListView: React.ComponentClass<ListViewOwnProps> = connect(null, mapDispatchToProps)(ListView);
